import { Navigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { useAuth } from '@/hooks/useAuth';
import { useRbac } from '@/hooks/useRbac';
import { ROUTES } from '@/constants/routes';

export interface PrivateRouteProps {
  element: React.ReactNode;
  /** Permission keys cần có (OR logic). Bỏ qua → chỉ cần authenticated. */
  requiredPermissions?: string[];
}

export function PrivateRoute({ element, requiredPermissions }: PrivateRouteProps) {
  const { isAuthenticated, user } = useAuth();
  const { hasAny, isLoading } = useRbac();

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.auth.login} replace />;
  }

  if (isLoading) {
    return null;
  }

  if (requiredPermissions && requiredPermissions.length > 0 && !hasAny(requiredPermissions)) {
    return (
      <Result
        status="403"
        title="Không có quyền"
        subTitle="Tài khoản của bạn không có quyền truy cập trang này."
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            Quay lại
          </Button>
        }
      />
    );
  }

  return <>{element}</>;
}
